import { GradientPath } from './GradientPath';

type Props = {
  className?: string;
};

export const House = ({ className }: Props) => (
  <GradientPath
    className={className}
    render={(id) => (
      <path
        fill={`url(#${id})`}
        d="m32.9 17.7-15.2-16.8c-.1-.2-.3-.2-.6-.2-.2 0-.4.1-.6.2l-15.3 16.8c-.2.2-.3.5-.2.8s.4.5.7.5h3.3v13.6c0 .4.3.8.8.8h22.8c.4 0 .8-.3.8-.8v-14c0-.4-.3-.8-.8-.8s-.8.3-.8.8v13.3h-21.3v-13.7c0-.4-.3-.8-.8-.8h-2.3l13.7-14.8 14.6 16.1c.3.3.8.3 1.1.1.3-.3.3-.8.1-1.1zm-20.3-2.1c-1.2 1.2-1.8 2.7-1.8 4.4s.6 3.2 1.8 4.4 2.7 1.8 4.4 1.8 3.2-.6 4.4-1.8 1.8-2.7 1.8-4.4-.6-3.2-1.8-4.4-2.7-1.8-4.4-1.8-3.2.6-4.4 1.8zm9.4 4.4c0 1.4-.5 2.6-1.5 3.5-1 1-2.1 1.5-3.5 1.5s-2.6-.5-3.5-1.5c-1-1-1.5-2.1-1.5-3.5s.5-2.6 1.5-3.5c1-1 2.1-1.5 3.5-1.5s2.6.5 3.5 1.5c1 1 1.5 2.1 1.5 3.5z"
      />
    )}
  />
);
